(() => {
  const root = document.querySelector('[data-pythal-bundle-builder]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const moneyFormat = root.dataset.moneyFormat || 'Dhs. {{amount}}';
  const currencyCode = root.dataset.currencyCode || 'AED';
  const minItems = Math.max(1, Number(root.dataset.minItems || 2));
  const maxItems = Math.max(minItems, Number(root.dataset.maxItems || 12));
  const cards = Array.from(root.querySelectorAll('[data-bundle-card]'));
  const summary = root.querySelector('[data-bundle-summary]');
  const summaryList = root.querySelector('[data-bundle-summary-list]');
  const emptyState = root.querySelector('[data-bundle-empty]');
  const countNode = root.querySelector('[data-bundle-count]');
  const inlineCount = root.querySelector('[data-bundle-inline-count]');
  const totalNode = root.querySelector('[data-bundle-total]');
  const submit = root.querySelector('[data-bundle-submit]');
  const submitLabel = root.querySelector('[data-bundle-submit-label]');
  const status = root.querySelector('[data-bundle-status]');
  const nameInput = root.querySelector('[data-bundle-name]');
  const searchInput = root.querySelector('[data-bundle-search]');
  const typeFilter = root.querySelector('[data-bundle-type-filter]');
  const resultsNote = root.querySelector('[data-bundle-results-note]');
  const progress = root.querySelector('[data-bundle-progress]');
  const progressCopy = root.querySelector('[data-bundle-progress-copy]');
  const mobileReview = root.querySelector('[data-bundle-mobile-review]');
  const mobileCount = root.querySelector('[data-bundle-mobile-count]');
  const mobileTotal = root.querySelector('[data-bundle-mobile-total]');
  const steps = Array.from(root.querySelectorAll('[data-bundle-step]'));
  const tray = root.querySelector('[data-bundle-tray]');
  const mobileThumbs = root.querySelector('[data-bundle-mobile-thumbs]');
  const noResults = root.querySelector('[data-bundle-no-results]');
  const moreWrap = root.querySelector('[data-bundle-more-wrap]');
  const moreButton = root.querySelector('[data-bundle-more]');
  const shownNode = root.querySelector('[data-bundle-shown]');
  const shownTotal = root.querySelector('[data-bundle-shown-total]');
  const shownBar = root.querySelector('[data-bundle-shown-bar]');
  const TRAY_SLOTS = 4;
  const PAGE_SIZE = 12;
  let visibleLimit = PAGE_SIZE;
  const selected = new Map();

  // Translated copy rendered by pythal-custom-bundle-builder.liquid; English stays as the fallback.
  const strings = (() => {
    try { return JSON.parse(root.querySelector('[data-bundle-strings]')?.textContent || '{}') || {}; }
    catch { return {}; }
  })();
  const decodeEntities = (value) => {
    if (!/&[#a-z0-9]+;/i.test(value)) return value;
    const node = document.createElement('textarea');
    node.innerHTML = value;
    return node.value;
  };
  const tr = (key, fallback) => (typeof strings[key] === 'string' && strings[key] ? decodeEntities(strings[key]) : fallback);
  const trTitle = (key, fallback, title) => tr(key, fallback).replace('__TITLE__', title);
  const PLURAL_SAMPLES = { zero: 0, one: 1, two: 2, few: 3, many: 11, other: 100 };
  let pluralRules = null;
  try { pluralRules = new Intl.PluralRules(document.documentElement.lang || 'en'); } catch { pluralRules = null; }
  const trCount = (key, count, fallback) => {
    const forms = strings.plural?.[key];
    if (!forms || typeof forms !== 'object') return fallback;
    let form = pluralRules ? pluralRules.select(count) : (count === 1 ? 'one' : 'other');
    if (typeof forms[form] !== 'string' || !forms[form]) form = 'other';
    if (typeof forms[form] !== 'string' || !forms[form]) return fallback;
    return decodeEntities(forms[form]).replace(String(PLURAL_SAMPLES[form]), String(count));
  };

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  }[char]));

  const formatMoney = (cents) => {
    const amount = (Number(cents || 0) / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    let formatted = `${currencyCode} ${amount}`;
    if (moneyFormat.includes('{{amount}}')) formatted = moneyFormat.replace('{{amount}}', amount);
    else if (moneyFormat.includes('{{ amount }}')) formatted = moneyFormat.replace('{{ amount }}', amount);
    // Same swap as snippets/pythal-money.liquid: the UAE Dirham symbol replaces "Dhs." / "AED". Returns HTML.
    if (!/Dhs\.|AED/.test(formatted)) return escapeHtml(formatted);
    return `<span class="pythal-aed" role="img" aria-label="AED">&#x20C3;</span>${escapeHtml(formatted.replace(/Dhs\.|AED/g, '').trim())}`;
  };

  const getVariantSelect = (card) => card.querySelector('[data-bundle-variant]');

  const parseVariantOptions = (option) => {
    try { return JSON.parse(option.dataset.optionValues || '[]'); }
    catch { return []; }
  };

  const getSelectedOptionValues = (card) => Array.from(card.querySelectorAll('[data-bundle-option-group]')).map((group) => {
    const checked = group.querySelector('[data-bundle-option-choice]:checked');
    return checked ? checked.value : '';
  });

  const findVariantForSelections = (card, selections) => {
    const select = getVariantSelect(card);
    if (!select) return null;
    return Array.from(select.options).find((option) => {
      const values = parseVariantOptions(option);
      return values.length === selections.length && values.every((value, index) => value === selections[index]);
    }) || null;
  };

  const getVariant = (card) => {
    const select = getVariantSelect(card);
    if (!select) return null;
    const option = select.options[select.selectedIndex];
    if (!option || option.disabled || option.dataset.available !== 'true') return null;
    return {
      id: Number(option.value),
      title: option.dataset.title || '',
      price: Number(option.dataset.price || 0),
      available: true,
    };
  };

  const syncOptionUI = (card) => {
    const select = getVariantSelect(card);
    if (!select) return;
    const groups = Array.from(card.querySelectorAll('[data-bundle-option-group]'));
    if (!groups.length) return;

    const selections = getSelectedOptionValues(card);
    const exact = findVariantForSelections(card, selections);
    const statusNode = card.querySelector('[data-bundle-variant-status]');
    const priceNode = card.querySelector('[data-bundle-card-price]');

    if (exact) {
      select.value = exact.value;
      if (priceNode) priceNode.innerHTML = formatMoney(Number(exact.dataset.price || 0));
      if (statusNode) {
        statusNode.textContent = exact.dataset.available === 'true' ? '' : tr('combination_sold_out', 'This combination is sold out.');
        statusNode.classList.toggle('is-error', exact.dataset.available !== 'true');
      }
    } else if (statusNode) {
      statusNode.textContent = tr('combination_unavailable', 'Choose an available combination.');
      statusNode.classList.add('is-error');
    }

    groups.forEach((group, groupIndex) => {
      const current = group.querySelector('[data-bundle-option-current]');
      const checked = group.querySelector('[data-bundle-option-choice]:checked');
      if (current) current.textContent = checked?.value || '';

      group.querySelectorAll('[data-bundle-option-choice]').forEach((input) => {
        const hypothetical = selections.slice();
        hypothetical[groupIndex] = input.value;
        const possible = Array.from(select.options).some((variantOption) => {
          const values = parseVariantOptions(variantOption);
          return variantOption.dataset.available === 'true' && values.length === hypothetical.length && values.every((value, index) => value === hypothetical[index]);
        });
        input.disabled = !possible && !input.checked;
      });
    });
  };

  const setStatus = (message = '', isError = false) => {
    if (!status) return;
    status.textContent = message;
    status.classList.toggle('is-error', Boolean(isError));
  };

  const getItemCount = () => Array.from(selected.values()).reduce((sum, item) => sum + item.quantity, 0);
  const getTotal = () => Array.from(selected.values()).reduce((sum, item) => sum + item.price * item.quantity, 0);

  const updateCardState = (productId) => {
    const card = root.querySelector(`[data-bundle-card][data-product-id="${CSS.escape(String(productId))}"]`);
    if (!card) return;
    const button = card.querySelector('[data-bundle-toggle]');
    const label = card.querySelector('[data-bundle-action-label]');
    const badge = card.querySelector('[data-bundle-card-badge]');
    const icon = card.querySelector('.py-bundle-card__action-icon');
    const isSelected = selected.has(String(productId));
    card.classList.toggle('is-selected', isSelected);
    if (badge) badge.hidden = !isSelected;
    if (button) {
      button.dataset.selected = isSelected ? 'true' : 'false';
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    }
    if (label) label.textContent = isSelected ? tr('added_to_bundle', 'Added to bundle') : tr('add_to_bundle', 'Add to bundle');
    if (icon) icon.textContent = isSelected ? '✓' : '+';
  };

  const updateStepState = (itemCount) => {
    steps.forEach((step) => {
      const number = Number(step.dataset.bundleStep || 1);
      const active = number === 1 ? itemCount < minItems : number === 2 ? itemCount >= minItems : false;
      step.classList.toggle('is-active', active);
      step.classList.toggle('is-complete', number === 1 && itemCount >= minItems);
    });
  };

  const render = () => {
    const entries = Array.from(selected.values());
    const itemCount = getItemCount();
    const total = getTotal();
    const remaining = Math.max(0, minItems - itemCount);
    const progressPercent = Math.min(100, (itemCount / minItems) * 100);

    if (countNode) countNode.textContent = trCount('items', itemCount, `${itemCount} ${itemCount === 1 ? 'item' : 'items'}`);
    if (inlineCount) inlineCount.textContent = String(itemCount);
    if (totalNode) totalNode.innerHTML = formatMoney(total);
    if (emptyState) emptyState.hidden = entries.length > 0;
    if (progress) progress.style.width = `${progressPercent}%`;
    if (progressCopy) progressCopy.textContent = remaining > 0 ? trCount('more_items', remaining, `Choose ${remaining} more ${remaining === 1 ? 'item' : 'items'} to continue`) : tr('ready', 'Your bundle is ready to review');
    updateStepState(itemCount);

    if (mobileReview) mobileReview.hidden = itemCount === 0;
    if (mobileCount) mobileCount.textContent = trCount('items', itemCount, `${itemCount} ${itemCount === 1 ? 'item' : 'items'}`);
    if (mobileTotal) mobileTotal.innerHTML = formatMoney(total);

    const thumb = (item) => item.image
      ? `<img src="${escapeHtml(item.image)}" alt="" width="80" height="80" loading="lazy">`
      : `<span>${escapeHtml((item.title || '?').charAt(0))}</span>`;

    if (tray) {
      const shown = entries.slice(0, TRAY_SLOTS);
      const overflow = entries.length - shown.length;
      const slots = shown.map((item, index) => `<span class="py-bundle-summary__slot is-filled" data-tray-id="${escapeHtml(item.productId)}">${thumb(item)}${item.quantity > 1 ? `<b>×${item.quantity}</b>` : ''}${overflow > 0 && index === shown.length - 1 ? `<i>+${overflow}</i>` : ''}</span>`);
      for (let i = shown.length; i < TRAY_SLOTS; i += 1) {
        slots.push(`<span class="py-bundle-summary__slot${i < minItems ? ' is-required' : ''}"></span>`);
      }
      const previous = new Set(Array.from(tray.querySelectorAll('[data-tray-id]')).map((node) => node.dataset.trayId));
      tray.innerHTML = slots.join('');
      tray.querySelectorAll('[data-tray-id]').forEach((node) => {
        if (!previous.has(node.dataset.trayId)) node.classList.add('is-new');
      });
    }
    if (mobileThumbs) mobileThumbs.innerHTML = entries.slice(0, 3).map((item) => `<span>${thumb(item)}</span>`).join('');
    summary?.classList.toggle('is-ready', itemCount >= minItems);

    if (summaryList) {
      summaryList.hidden = entries.length === 0;
      summaryList.innerHTML = entries.map((item) => `
        <li class="py-bundle-summary__item" data-summary-product-id="${escapeHtml(item.productId)}">
          <div class="py-bundle-summary__image">${item.image ? `<img src="${escapeHtml(item.image)}" alt="" width="104" height="104" loading="lazy">` : ''}</div>
          <div>
            <div class="py-bundle-summary__item-head">
              <div><p class="py-bundle-summary__name">${escapeHtml(item.title)}</p>${item.variantTitle && item.variantTitle !== 'Default Title' ? `<p class="py-bundle-summary__variant">${escapeHtml(item.variantTitle)}</p>` : ''}</div>
              <button type="button" class="py-bundle-summary__remove" data-bundle-remove="${escapeHtml(item.productId)}" aria-label="${escapeHtml(trTitle('remove_item', 'Remove __TITLE__', item.title))}">×</button>
            </div>
            <div class="py-bundle-summary__item-foot">
              <div class="py-bundle-summary__qty" aria-label="${escapeHtml(trTitle('quantity_for', 'Quantity for __TITLE__', item.title))}"><button type="button" data-bundle-qty-minus="${escapeHtml(item.productId)}" aria-label="${escapeHtml(tr('decrease_quantity', 'Decrease quantity'))}">−</button><span>${item.quantity}</span><button type="button" data-bundle-qty-plus="${escapeHtml(item.productId)}" aria-label="${escapeHtml(tr('increase_quantity', 'Increase quantity'))}">+</button></div>
              <span class="py-bundle-summary__line-price">${formatMoney(item.price * item.quantity)}</span>
            </div>
          </div>
        </li>`).join('');
    }

    const withinLimits = itemCount >= minItems && itemCount <= maxItems;
    if (submit) submit.disabled = !withinLimits || entries.length === 0;
    if (submitLabel) submitLabel.textContent = withinLimits ? tr('add_bundle_to_cart', 'Add bundle to cart') : trCount('choose_min', minItems, `Choose ${minItems}+ items`);
    if (!withinLimits && itemCount > 0) setStatus(itemCount < minItems ? trCount('min_items_status', minItems, `Choose at least ${minItems} items to build your bundle.`) : trCount('max_items_status', maxItems, `This bundle can contain up to ${maxItems} items.`), true);
    else setStatus('');
  };

  const addCard = (card) => {
    const productId = String(card.dataset.productId || '');
    if (!productId) return;
    if (selected.has(productId)) {
      selected.delete(productId);
      updateCardState(productId);
      render();
      return;
    }
    const variant = getVariant(card);
    if (!variant) {
      setStatus(tr('choose_option_first', 'Please choose an available option before adding this item.'), true);
      return;
    }
    if (getItemCount() >= maxItems) {
      setStatus(trCount('max_items_status', maxItems, `This bundle can contain up to ${maxItems} items.`), true);
      return;
    }
    selected.set(productId, { productId, variantId: variant.id, variantTitle: variant.title, price: variant.price, title: card.dataset.productTitle || '', image: card.dataset.productImage || '', quantity: 1 });
    updateCardState(productId);
    render();
  };

  // Search and the category filter pick the matching pieces; "View more" reveals them PAGE_SIZE at a time.
  const filterCards = () => {
    const term = (searchInput?.value || '').trim().toLowerCase();
    const filter = (typeFilter?.value || '').trim().toLowerCase();
    let visible = 0;
    let shown = 0;
    cards.forEach((card) => {
      const haystack = (card.dataset.searchText || '').toLowerCase();
      let categoryMatch = true;
      if (filter.startsWith('collection:')) {
        const handle = filter.slice('collection:'.length);
        const categories = (card.dataset.productCategories || '').toLowerCase().split('|').filter(Boolean);
        categoryMatch = categories.includes(handle);
      } else if (filter.startsWith('type:')) {
        const type = filter.slice('type:'.length);
        categoryMatch = (card.dataset.productType || '').toLowerCase() === type;
      }
      const matches = (!term || haystack.includes(term)) && categoryMatch;
      if (matches) visible += 1;
      const show = matches && visible <= visibleLimit;
      card.hidden = !show;
      if (show) shown += 1;
    });
    if (resultsNote) resultsNote.textContent = trCount('pieces', visible, `${visible} ${visible === 1 ? 'piece' : 'pieces'} to choose from`);
    if (noResults) noResults.hidden = visible > 0 || cards.length === 0;
    if (moreWrap) moreWrap.hidden = visible <= PAGE_SIZE;
    if (moreButton) moreButton.hidden = shown >= visible;
    if (shownNode) shownNode.textContent = String(shown);
    if (shownTotal) shownTotal.textContent = tr('progress_of', 'of __TOTAL__ pieces').replace('__TOTAL__', String(visible));
    if (shownBar) shownBar.style.width = `${visible ? (shown / visible) * 100 : 0}%`;
  };

  const resetPaging = () => {
    visibleLimit = PAGE_SIZE;
    filterCards();
  };

  root.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-bundle-toggle]');
    if (toggle) {
      const card = toggle.closest('[data-bundle-card]');
      if (card) addCard(card);
      return;
    }
    const remove = event.target.closest('[data-bundle-remove]');
    if (remove) {
      const id = String(remove.dataset.bundleRemove || '');
      selected.delete(id); updateCardState(id); render(); return;
    }
    const minus = event.target.closest('[data-bundle-qty-minus]');
    if (minus) {
      const id = String(minus.dataset.bundleQtyMinus || '');
      const item = selected.get(id); if (!item) return;
      if (item.quantity <= 1) selected.delete(id); else item.quantity -= 1;
      updateCardState(id); render(); return;
    }
    const plus = event.target.closest('[data-bundle-qty-plus]');
    if (plus) {
      const id = String(plus.dataset.bundleQtyPlus || '');
      const item = selected.get(id); if (!item) return;
      if (getItemCount() >= maxItems) { setStatus(trCount('max_items_status', maxItems, `This bundle can contain up to ${maxItems} items.`), true); return; }
      item.quantity += 1; render(); return;
    }
    const resetFilters = event.target.closest('[data-bundle-reset-filters]');
    if (resetFilters) {
      if (searchInput) searchInput.value = '';
      if (typeFilter) typeFilter.value = '';
      resetPaging();
      searchInput?.focus();
      return;
    }
    if (event.target.closest('[data-bundle-more]')) {
      const firstNew = cards.filter((card) => card.hidden === false).length;
      visibleLimit += PAGE_SIZE;
      filterCards();
      // Keep keyboard users in place: move focus to the first newly revealed piece.
      const revealed = cards.filter((card) => card.hidden === false)[firstNew];
      revealed?.querySelector('[data-bundle-toggle]')?.focus({ preventScroll: true });
      return;
    }
    const mobileReviewButton = event.target.closest('[data-bundle-mobile-review]');
    if (mobileReviewButton && summary) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      summary.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      summary.focus({ preventScroll: true });
    }
  });

  root.addEventListener('change', (event) => {
    const choice = event.target.closest('[data-bundle-option-choice]');
    if (choice) {
      const card = choice.closest('[data-bundle-card]');
      if (!card) return;
      syncOptionUI(card);
      const productId = String(card.dataset.productId || '');
      if (selected.has(productId)) {
        const variant = getVariant(card);
        if (!variant) {
          selected.delete(productId);
          updateCardState(productId);
        } else {
          const item = selected.get(productId);
          item.variantId = variant.id;
          item.variantTitle = variant.title;
          item.price = variant.price;
        }
        render();
      }
      return;
    }
  });

  searchInput?.addEventListener('input', resetPaging);
  typeFilter?.addEventListener('change', resetPaging);

  submit?.addEventListener('click', async () => {
    const entries = Array.from(selected.values());
    const itemCount = getItemCount();
    if (itemCount < minItems || itemCount > maxItems || entries.length === 0) { render(); return; }
    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    if (submitLabel) submitLabel.textContent = tr('adding', 'Adding bundle…');
    setStatus(tr('adding_status', 'Adding your bundle to cart…'));
    steps.forEach((step) => step.classList.toggle('is-active', step.dataset.bundleStep === '3'));

    const bundleId = `PYTHAL-${Date.now().toString(36).toUpperCase()}`;
    const bundleName = (nameInput?.value || '').trim() || tr('default_name', 'My Pythal Bundle');
    const payload = { items: entries.map((item) => ({ id: item.variantId, quantity: item.quantity, properties: { '_Pythal Bundle ID': bundleId, '_Pythal Bundle Name': bundleName } })) };

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.description || data.message || tr('add_error', 'Unable to add this bundle to cart.'));
      setStatus(tr('added_status', 'Bundle added. Opening your cart…'));
      window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
    } catch (error) {
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
      if (submitLabel) submitLabel.textContent = tr('add_bundle_to_cart', 'Add bundle to cart');
      setStatus(error?.message || tr('add_error_retry', 'Unable to add this bundle. Please try again.'), true);
      updateStepState(itemCount);
    }
  });

  // Tuck the floating mobile bar away while the summary itself is on screen.
  if (mobileReview && summary && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      mobileReview.classList.toggle('is-tucked', entry.isIntersecting);
    }, { rootMargin: '0px 0px -80px 0px' }).observe(summary);
  }

  cards.forEach(syncOptionUI);
  filterCards();

  // Pieces picked in the homepage gift box arrive as ?pick=<product id>,<product id>.
  const params = new URLSearchParams(window.location.search);
  const picks = (params.get('pick') || '').split(',').filter(Boolean);
  if (nameInput && params.get('name')) nameInput.value = params.get('name').slice(0, 50);
  picks.forEach((id) => {
    const card = cards.find((item) => item.dataset.productId === id);
    if (card && !selected.has(id)) addCard(card);
  });

  render();
  if (selected.size) setStatus(tr('picks_loaded', 'Your picks are in the bundle. Check sizes, then add it to cart.'));
})();
